<template>
  <div>
    <v-container>
      <!-- <h2>
        LIVE AUCTION -->
      <!-- <v-modal-help style="font-size:17px">
          <div slot="body">
            <v-card-text>
              <h3 class="mb-2">LINE auction (บีคอน)</h3>
              <p style="color:black">
                เป็นเทคโนโลยีที่ใช้สำหรับการส่งข้อความในไลน์ผ่าน Bluetooth ได้ฟรี โดยไม่เสียค่า Push
                Message โดยเมื่อเราเดินเข้าไปในรัศมีที่มี LINE auction ส่งสัญญาณถึง
                ก็จะได้รับข้อความ รูปภาพ ที่ร้านค้าตั้งไว้ทันที
              </p>
            </v-card-text>
          </div>
        </v-modal-help> -->
      <!-- </h2> -->

      <div>
        <div style="margin-bottom: 10px;">
          <a
            href="javascript:void(0);"
            v-if="!isShow"
            @click="
              isShow = true
              auctionItem = {}
            "
          >
            <div class="add-conversation text-xs-center">
              <i class="fa fa-plus middle"></i>
              {{ $t('add_auction_information') }}
            </div>
          </a>
          <auction-form
            @currentViewDashBoard="currentViewDashBoard"
            @setAuctionId="setAuctionId"
            :isShow.sync="isShow"
            @getLiveAuction="getLiveAuction"
            v-else
            v-model="auctionItem"
          ></auction-form>
        </div>
        <div v-if="loading">
          <div class="spinner text-xs-center mb-5 mt-5">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
        </div>
        <div v-else>
          <template v-if="data">
            <div class="text-xs-right mb-2">
              <v-pagination
                :total-visible="5"
                v-model="pageNumber"
                :length="pagelength"
                @input="changePage"
              ></v-pagination>
            </div>
            <template v-for="(item, index) in data">
              <auction-edit
                @currentViewDashBoard="currentViewDashBoard"
                @setAuctionId="setAuctionId"
                :isShow.sync="isShow"
                @getLiveAuction="getLiveAuction"
                v-model="isEdit"
                :itemEdit="item"
                :key="index"
              ></auction-edit>
            </template>
            <div class="text-xs-right">
              <v-pagination
                :total-visible="5"
                v-model="pageNumber"
                :length="pagelength"
                @input="changePage"
              ></v-pagination>
            </div>
          </template>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import AuctionForm from '@/components/view/liveAuction/AuctionForm'
import AuctionEdit from '@/components/view/liveAuction/AuctionEdit'
import { cloneDeep } from 'lodash'

export default {
  props: ['value', 'auctionId'],
  data() {
    return {
      pageNumber: 1,
      pagelength: 0,
      isShow: false,
      data: null,
      auctionItem: {},
      loadingDelete: false,
      isEdit: false,
      loading: false,
      limit: 5,
      offset: 0
    }
  },
  components: {
    AuctionForm,
    AuctionEdit
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    const vm = this
    vm.getLiveAuction()
  },
  methods: {
    changePage() {
      const vm = this
      vm.offset = vm.pageNumber * vm.limit - vm.limit
      vm.getLiveAuction()
    },
    currentViewDashBoard(page) {
      const vm = this
      vm.$emit('input', page)
    },
    setAuctionId(auctionId) {
      const vm = this
      vm.$emit('setAuctionId', auctionId)
    },
    async getLiveAuction() {
      const vm = this
      vm.loading = true
      vm.data = null
      const data = {
        pageid: vm.selectedBot.pageid,
        params: {
          with_product: true,
          filter_status: 'draft',
          limit: vm.limit,
          offset: vm.offset
        }
      }
      let response = await api.getLiveAuction(data)
      if (response.success && response.result) {
        vm.data = response.result
        // .sort(
        //   (a, b) =>
        //     new Date(b.updated_at ? b.updated_at : b.created_at) -
        //     new Date(a.updated_at ? a.updated_at : a.created_at)
        // )
        vm.pagelength = Math.ceil(response.total_count / vm.limit)
      }
      vm.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/view/liveAuction/LiveAuction.vue